/* eslint react/prop-types: 0 */
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Input } from '@hotjar/webapp/components/Input';
import { tokens } from '@hotjar/hotsauce';

const StyledInput = styled(Input)`
  border: 0;
  border-bottom: 1px dashed ${tokens.color.ui_border};
  border-radius: 0;
  font-size: 14px;
  font-weight: 600;
  box-shadow: none;
  width: auto;

  /* Hide the clear button in IE and Edge. For some reason the button doesn't work.
     * This is probably related to the IE bug with fields inside a draggable container - see below.
     */
  ::-ms-clear {
    display: none;
  }

  &:hover {
    border-color: ${tokens.color.ui_border_alt};
    background: ${tokens.color.neutral_100};
  }

  &:focus {
    border-color: ${tokens.color.ui_background};
    background: ${tokens.color.ui_background};
  }

  &.rtl {
    direction: rtl;
  }

  &.error {
    border-color: ${tokens.color.ui_border_danger} !important;
    border-bottom-style: solid !important;
    background-color: ${tokens.color.bg_danger} !important;
  }
`;

const textAreaStyles = css`
  resize: vertical;
`;

export const TextField = ({ className, rtl, hasError, onMouseDown, multiline, ...otherProps }) => {
  const handleMouseDown = (evt) => {
    // IE11 cannot properly focus on a field when wrapped in a draggable container.
    // See: https://github.com/react-dnd/react-dnd/issues/463#issuecomment-328036575
    // So force a focus here.
    //
    // Note: in IE11 the text cursor position is still often wrong but I couldn't find a way to fix it :(
    // Note2: IE11 clear button doesn't seem to be working.
    // Note3: in IE11 double-click to select doesn't work.
    evt.target.focus();

    if (onMouseDown) {
      onMouseDown(evt);
    }
  };

  return (
    <StyledInput
      as={multiline ? 'textarea' : undefined}
      css={[multiline && textAreaStyles]}
      rows={multiline && 2}
      type={!multiline ? 'text' : undefined}
      className={[className, rtl ? 'rtl' : '', hasError ? 'error' : ''].join(' ')}
      onMouseDown={handleMouseDown}
      /* FIXME: react/jsx-props-no-spreading */
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...otherProps}
    />
  );
};
